// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptySearch_wrapper__ImNbR","search":"EmptySearch_search__EMbXp","firstChild":"EmptySearch_firstChild__giCv9","lastChild":"EmptySearch_lastChild__B0C5t"};